import { render, staticRenderFns } from "./QuestionAnswerReport.vue?vue&type=template&id=37cff006&scoped=true"
import script from "./QuestionAnswerReport.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerReport.vue?vue&type=script&lang=js"
import style0 from "./QuestionAnswerReport.vue?vue&type=style&index=0&id=37cff006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cff006",
  null
  
)

export default component.exports